import type { HTMLAttributes, TdHTMLAttributes, ThHTMLAttributes } from "react";
import { cn } from "../../lib/cn";

export const Table = ({ className, ...props }: HTMLAttributes<HTMLTableElement>) => (
	<div className="w-full overflow-x-auto">
		<table className={cn("w-full border-collapse text-sm", className)} {...props} />
	</div>
);

export const THead = ({ className, ...props }: HTMLAttributes<HTMLTableSectionElement>) => (
	<thead className={cn("border-b border-line", className)} {...props} />
);

export const TBody = ({ className, ...props }: HTMLAttributes<HTMLTableSectionElement>) => (
	<tbody className={cn("divide-y divide-line", className)} {...props} />
);

export const TR = ({ className, ...props }: HTMLAttributes<HTMLTableRowElement>) => (
	<tr className={cn("transition-colors", className)} {...props} />
);

export const TH = ({ className, ...props }: ThHTMLAttributes<HTMLTableCellElement>) => (
	<th
		className={cn(
			"px-3 py-2 text-left text-xs font-medium tracking-wide text-ink-muted uppercase",
			className,
		)}
		{...props}
	/>
);

export const TD = ({ className, ...props }: TdHTMLAttributes<HTMLTableCellElement>) => (
	<td className={cn("px-3 py-3 align-middle text-ink", className)} {...props} />
);
